import { motion } from "framer-motion";
import { ScrollMaskedLines } from "./MaskedText";

export default function Dedication() {
    return (
        <section
            data-testid="dedication-section"
            className="relative w-full min-h-[100svh] bg-neutral-950 text-neutral-50 flex items-center overflow-hidden"
        >
            {/* Faint candle image */}
            <div className="absolute inset-0 opacity-[0.28]">
                <img
                    src="/scenes/candle_flame.png"
                    alt=""
                    aria-hidden="true"
                    className="editorial-img w-full h-full object-cover"
                />
            </div>
            <div className="absolute inset-0 bg-gradient-to-b from-neutral-950/70 via-neutral-950/30 to-neutral-950/90" />

            <div className="relative w-full max-w-[92rem] mx-auto px-6 sm:px-12 lg:px-16 py-32 grid grid-cols-12 gap-6">
                <div className="col-span-12 sm:col-span-3 font-sans text-[10px] uppercase tracking-[0.35em] text-neutral-400">
                    Coda
                </div>
                <div className="col-span-12 sm:col-span-9">
                    <ScrollMaskedLines
                        as="h2"
                        className="font-serif text-6xl sm:text-8xl lg:text-[10vw] leading-[0.9] tracking-tight text-neutral-50"
                        lines={["For Danielle.", "Always for", "Danielle."]}
                        stagger={0.25}
                        duration={1.2}
                    />

                    <motion.p
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true, margin: "-20%" }}
                        transition={{ duration: 1.4, delay: 0.8 }}
                        className="mt-16 font-serif italic text-2xl sm:text-3xl leading-snug text-neutral-200 max-w-2xl"
                    >
                        August 5, 1993 — October 6, 2021. Kept by her mother, Rebecca. Never forgotten.
                    </motion.p>

                    <motion.div
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 1.4, delay: 1.2 }}
                        className="mt-16 sm:mt-24 flex items-center gap-4 font-sans text-[10px] uppercase tracking-[0.4em] text-neutral-500"
                    >
                        <span className="w-16 h-px bg-neutral-500" />
                        <span>End of the record.</span>
                        <span>The story continues.</span>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
